import {
   createStore,
   combineReducers,
   compose,
   applyMiddleware,
} from 'redux';
import ReduxThunk from 'redux-thunk'
import { appReducer } from './appReducer';
import contactReducer from "./contactReducer";
import contactMtReducer from "./contactMtReducer";
import blogReducer from "./blogReducer";
import contactDcReducer from './contactDcReducer'

// if you're using redux-thunk or other middlewares, add them here
const createStoreWithMiddleware = compose(applyMiddleware(
   ReduxThunk,
))(createStore);
const rootReducer = combineReducers({
   app           : appReducer,
   contactHrtable: contactReducer,
   contactMt     : contactMtReducer,
   blogMT        : blogReducer,
   contactDc     : contactDcReducer,
});
export default function configureStore(initialState = {}) {
   return createStoreWithMiddleware(rootReducer, initialState);
};



// WEBPACK FOOTER //
// ./src/store/configureStore.js